import { actions } from "@/redux/reducers/User";
import { getUserActions } from "@/Common/api/users";

const onAddUserAuthorizationCallback = async ({ result, localUser, dispatch, location }) => {
	const user = result.data.onAddUserAuthorization;
	if (user._id === localUser._id) {
		const userActions = await getUserActions(user._id, location.locationId);
		if (userActions) {
			dispatch(actions.SET_USER_ACTIONS({ actions: userActions.actions || [] }));
		}
	}
};

const onDeleteUserAuthorizationCallback = async ({ result, localUser, dispatch, location }) => {
	const user = result.data.onDeleteUserAuthorization;
	if (user._id === localUser._id) {
		const userActions = await getUserActions(user._id, location.locationId);
		if (userActions) {
			dispatch(actions.SET_USER_ACTIONS({ actions: userActions.actions || [] }));
		}
	}
};
const onAddUserAuthorizationLocationCallback = async ({ result, localUser, dispatch, location }) => {
	const user = result.data.onAddUserAuthorizationLocation;
	if (user._id === localUser._id) {
		const userActions = await getUserActions(user._id, location.locationId);
		if (userActions) {
			dispatch(actions.SET_USER_ACTIONS({ actions: userActions.actions || [] }));
		}
	}
};

const onDeleteUserAuthorizationLocationCallback = async ({ result, localUser, dispatch, location }) => {
	const user = result.data.onDeleteUserAuthorizationLocation;
	if (user._id === localUser._id) {
		const userActions = await getUserActions(user._id, location.locationId);
		if (userActions) {
			dispatch(actions.SET_USER_ACTIONS({ actions: userActions.actions || [] }));
		}
	}
};

const onDeleteUserGroupCallback = async ({ result, localUser, dispatch, location }) => {
	const userGroup = result.data?.onDeleteUserGroup;
	const userId = localUser?._id;
	if (userGroup?.groupActions?.length && userId) {
		const userActions = await getUserActions(userId, location.locationId);
		if (userActions) {
			dispatch(actions.SET_USER_ACTIONS({ actions: userActions.actions || [] }));
		}
	}
};

const onGroupAccessModificationsCallback = async ({ result, localUser, dispatch, location }) => {
	const userGroup = result.data?.onGroupAccessModifications;
	const userId = localUser?._id;
	if (userGroup?.users?.length && userId) {
		const isUserPresent = userGroup.users.some((element) => element._id === userId);
		if (isUserPresent) {
			const userActions = await getUserActions(userId, location.locationId);
			if (userActions) {
				dispatch(actions.SET_USER_ACTIONS({ actions: userActions.actions || [] }));
			}
		}
	}
};

export {
	onAddUserAuthorizationCallback,
	onDeleteUserAuthorizationCallback,
	onAddUserAuthorizationLocationCallback,
	onDeleteUserAuthorizationLocationCallback,
	onDeleteUserGroupCallback,
	onGroupAccessModificationsCallback,
};
